import React, { useEffect, useState } from "react";
import * as ReactBootstrap from "react-bootstrap";
import searchicon from "../../../assets/icons/searchIcon.svg";
import addIcon from "../../../assets/icons/add-circle.svg";
import PaginationComponent from "../../../utilities/Pagination";
import "./AffiliateTable.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import { tokenConfig } from "../../../store/reducers/tokenReducer";
import { myStore } from "../../..";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";

function AffiliateTable({ handleShowAffiliate, paramsValue, setParamsValue }) {
  const { paginated_affiliates } = useSelector((state) => state.affiliate);
  const [pageSize, setPageSize] = useState(10);
  const [affiliateList, setAffiliateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Calculate pagination values
  const totalItems = affiliateList?.count || 0;
  const totalPages = Math.ceil(totalItems / pageSize);

  let searchTimeout;

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      setParamsValue((prev) => ({ ...prev, search: value, page: 1 }));
    }, 300);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setParamsValue((prev) => ({ ...prev, page }));
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setParamsValue((prev) => ({ ...prev, page: 1, page_size: newPageSize }));
  };

  const fetchAffiliate = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(`/affiliate/v2/code/list`, {
        params: { ...paramsValue, page_size: pageSize },
        ...tokenConfig(myStore.getState),
      });
      setAffiliateList(response.data || []);
    } catch (error) {
      console.error("Error fetching affiliates:", error);
      setError(
        error.response?.data?.message || "Failed to fetch affiliate list."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAffiliate();
  }, [paramsValue, pageSize]);

  const handleCopyToClipboard = (text) => {
    if (text) {
      toast("Affiliate Link Copied!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
        theme: "dark",
        className: "custom-toast-container",
      });
    }
  };

  return (
    <div
      className="LeaderboardPage PaymentHistoryPage affiliateTable"
      style={{ position: "relative", width: "100%" }}
    >
      <div className="HistoryDesk">
        <div className="table_header">
          <div className="table_header_left">
            <div className="search_bar_wrapper">
              <img src={searchicon} alt="searchicon" />
              <input
                type="text"
                className="search_input"
                placeholder="Search..."
                onChange={handleSearchChange}
                style={{borderRadius:"0px"}}
              />
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={handleShowAffiliate}
            className="create_btn"
          >
            <img src={addIcon} alt="add icon" />
            <p>Create Affiliate Code</p>
          </div>
        </div>

        {loading ? (
          <div className="loading">Loading...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : affiliateList?.results?.length === 0 ? (
          <div className="no-data">No affiliates found.</div>
        ) : (
          <>
            <div className="affiliateTableContainer">
              <ReactBootstrap.Table className="LeaderboardTable">
                <thead>
                  <tr>
                    <th style={{ paddingLeft: "20px" }}>Code</th>
                    <th>Percentage</th>
                    <th>Affiliate Link</th>
                    <th>Pushed Leads</th>
                    <th>Consumed by Count</th>
                    <th>Repeat Percent</th>
                  </tr>
                </thead>
                <tbody>
                  {affiliateList?.results?.map((data, key) => (
                    <tr key={key}>
                      <td style={{ paddingLeft: "20px" }}>{data.code}</td>
                      <td>{data.percentage || "N/A"}</td>
                      <td>
                        <a
                          // href={data.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="aff_code_url"
                        >
                          <span>{data.url.substring(0, 20)}...</span>
                          <CopyToClipboard
                            onCopy={() => handleCopyToClipboard(data.url)}
                            text={data.url}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="copy_icon"
                              style={{ cursor: "pointer" }}
                            >
                              <path
                                d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z"
                                fill="#B0B0B0"
                              />
                            </svg>
                          </CopyToClipboard>
                        </a>
                      </td>
                      <td>{data.pushed_leads}</td>
                      <td>{data.consumed_by_count}</td>
                      <td>{data.repeat_percent || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </ReactBootstrap.Table>
            </div>
            <PaginationComponent
              currentPage={paramsValue.page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              pageSize={pageSize}
              setPageSize={handlePageSizeChange}
              totalItems={totalItems}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default AffiliateTable;